var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { Inset } from "syf-component-library/ui/spacing";
import { H1, H4 } from "syf-component-library/ui/typography";
export var BigIcon = styled(FontAwesomeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #caa416;\n  font-size: 15rem;\n"], ["\n  color: #caa416;\n  font-size: 15rem;\n"])));
/**
 * Stretches to fit full height of container, put padded elements inside to prevent
 * a single element with height: 100% + padding from overflowing.
 */
export var FullHeightContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  height: 100%;\n"], ["\n  display: grid;\n  height: 100%;\n"])));
/**
 * Padded, horizontally and vertically centered items container with contents packed together
 */
export var CenterStackedInset = styled(Inset)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  grid-auto-flow: row;\n  justify-items: center;\n  align-content: center;\n"], ["\n  display: grid;\n  grid-auto-flow: row;\n  justify-items: center;\n  align-content: center;\n"])));
export var Title = styled(H1)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
export var Subtitle = styled(H4)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
